import { useNavigate } from 'react-router-dom'
import { logoutUser, setUserInfo } from '../store/features/auth/authSlice'
import decodeToken from '../utils/decodeToken'
import { UserAuth } from './../store/features/auth/type'
import useLocalStorage from './useLocalStorage'
import { useAppDispatch } from './useStore'
import { UserRole } from '../types/generalType'

const userValue: UserAuth = {
  userId: '',
  accessToken: '',
  exp: 0,
  family: '',
  name: '',
  nationalCode: '',
  role: [],
  provinceBrokerId: '',
  phoneNumber: '',
}

const storageKey = 'user'

const useAuth = () => {
  const [user, setUser] = useLocalStorage(storageKey, userValue)
  const navigate = useNavigate()
  const dispatch = useAppDispatch()

  const setUserinfomation = () => {
    if (typeof user.accessToken !== 'undefined') {
      const userInfo = decodeToken(user.accessToken)
      const isValidToken = new Date().getTime() / 1000.0 >= userInfo.exp ? false : true
      if (user.role.length && isValidToken) {
        dispatch(setUserInfo(userInfo))
      } else {
        logOut()
      }
    }
  }

  const isAdministrator = user?.role.includes(UserRole.AdMINISTRATOR)
  const isAdminWatcher = user?.role.includes(UserRole.AdminWatcher)
  const isAccountant = user?.role.includes(UserRole.Accountant)

  const logOut = () => {
    dispatch(logoutUser())
    localStorage.removeItem(storageKey)
    navigate('/Auth')
  }

  return {
    user,
    setUser,
    logOut,
    isAdministrator,
    isAdminWatcher,
    isAccountant,
    setUserinfomation,
  }
}

export default useAuth
